/* unplugin-vue-components disabled */import script from "./PreviewText.vue?vue&type=script&lang=ts&setup=true"
export * from "./PreviewText.vue?vue&type=script&lang=ts&setup=true"

import "./PreviewText.vue?vue&type=style&index=0&id=5f0e7fbc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f0e7fbc"]])

export default __exports__